import { PhoneSupportCallAddRequest, PhoneSupportCategoryDto } from "interfaces/Mueller.Business.Models";
import { HTTP_GET, HTTP_POST, WebApiRequest } from "tools/webservice";

export const addPhoneSupportCall = (payload: PhoneSupportCallAddRequest, successCallback:(newId: number) => void, mountedRef: { current: boolean }) => WebApiRequest({
  method: HTTP_POST,
  endpoint: "/phone-support-calls",
  payload,
  successCallback,
  mountedRef,
});

export const getPhoneSupportCategories = (successCallback: (categories: PhoneSupportCategoryDto[]) => void, mountedRef: { current: boolean }) => WebApiRequest({
  method: HTTP_GET,
  endpoint: "/phone-support-calls/categories",
  successCallback,
  mountedRef,
});
